import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { B06aProfileInfoPage } from '../b06a-profile-info/b06a-profile-info';

/**
 * Generated class for the B06SettingPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

 
@IonicPage()
@Component({
  selector: 'page-b06-setting',
  templateUrl: 'b06-setting.html',
})
export class B06SettingPage {

  USER_ID: any;
  USERNAME: any;
  BRANCH_ID: any;
  BRANCH_NAME: any;
  GRP_ID: any;
  GRP_NAME: any;
  CORP_ID: any;
  CORP_NAME: any;

  constructor(public navCtrl: NavController, public navParams: NavParams) {

    this.USERNAME = sessionStorage.getItem('username');
    this.USER_ID = sessionStorage.getItem('userid');
    this.BRANCH_ID = sessionStorage.getItem('userbranchid');
    //branch name
    this.GRP_ID = sessionStorage.getItem('usergroupid');
    this.GRP_NAME = sessionStorage.getItem('usergroupname');
    this.CORP_ID = sessionStorage.getItem('usercorpid');
    this.CORP_NAME = sessionStorage.getItem('usercorpname');
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad B06SettingPage');
  }

  editAccount(){
    this.navCtrl.push(B06aProfileInfoPage, {paramID: this.USER_ID});
  }
}



// WEBPACK FOOTER //
// ./src/pages/b06-setting/b06-setting.ts